const linkedinSummary = (
  <div className="internhub-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">
        Getting Started with LinkedIn for Career Success
      </h3>
      <ul className="list-disc pl-6">
        <li>
          LinkedIn is a professional networking platform for connecting with others, finding jobs,
          and showcasing your skills.
        </li>
        <li>Optimizing your profile helps recruiters and industry professionals find you.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Building a Strong Profile</h3>
      <ul className="list-disc pl-6">
        <li>
          <strong>Profile Picture:</strong> Use a clear, professional-looking photo.
        </li>
        <li>
          <strong>Headline:</strong> Describe your skills and career goals (e.g., “CS @ [University]
          | Aspiring Software Engineer”).
        </li>
        <li>
          <strong>About Section:</strong> Write a short summary about your experience, interests,
          and career aspirations.
        </li>
        <li>
          <strong>Experience & Projects:</strong> Showcase internships, class projects, and any work
          relevant to your field.
        </li>
        <li>
          <strong>Skills:</strong> Add programming languages, frameworks, and industry-specific
          tools.
        </li>
        <li>
          <strong>Recommendations:</strong> Ask professors, mentors, or teammates for short
          endorsements of your work.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Using LinkedIn for Networking & Job Searching</h3>
      <ul className="list-disc pl-6">
        <li>Connect with classmates, professors, and professionals in your field.</li>
        <li>Engage with industry posts and share insights to build visibility.</li>
        <li>
          Use the 'Open to Work' feature to let recruiters know you’re looking for opportunities.
        </li>
        <li>
          Apply for jobs directly through LinkedIn and reach out to recruiters with personalized
          messages.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Maximizing Your LinkedIn Presence</h3>
      <ul className="list-disc pl-6">
        <li>Regularly update your profile with new projects, skills, and experiences.</li>
        <li>Follow companies and join LinkedIn groups related to your industry.</li>
        <li>Stay active by commenting on posts and sharing professional insights.</li>
      </ul>
    </div>
  </div>
);

export default linkedinSummary;
